/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  accountIdentification: "Account identification",
  accountNumber: "Account number",
  accountProvider: "Account provider",
  accounts: "Accounts",
  add: "Add",
  automatic: "Automatic",
  balance: "Balance",
  bankAccountDetailsLikeIbanAndSwiftCode:
    "Bank account details like IBAN and Swift code (BIC). Account number, sort code or PIX key can be displayed for particular currencies.",
  bsb: "BSB",
  cancel: "Cancel",
  cashManagementProviderConfig:
    "Cash management {{providerName}} config details",
  clearJunctionBalance: "Clear Junction Balance",
  clearJunctionBalanceCurrency: "Clear Junction Balance ({{currency}})",
  companyUuid: "Company UUID",
  configurableProviders: "Configurable providers",
  configureProviderSettings: "Configure provider settings - {{providerName}}",
  confirmationCode: "Confirmation code",
  createConfig: "Create config",
  currency: "Currency",
  edit: "Edit",
  enable: "Enable",
  iban: "IBAN",
  id: "ID",
  minimumReserveBalance: "Minimum reserve balance",
  nextSettlement: "Next settlement",
  notificationsAreActive:
    "Notifications are active and your are receiving notifications.",
  payoutNotifications: "Payout notifications",
  payoutNotificationsSettingsEnabled:
    "Payout notification settings enabled flag toggled successfully",
  payoutNotificationsSettingsHaveBeenCreated:
    "Payout notifications settings have been created",
  payoutNotificationsSettingsHaveBeenUpdated:
    "Payout notifications settings have been updated",
  pixKey: "Pix Key",
  providerName: "Provider name",
  providers: "Providers",
  refreshBalance: "Refresh Balance",
  requestingSettlement: "Requesting settlement",
  sendSettlementBatches: "Send Settlement Batches",
  settle: "Settle",
  settlement: "Settlement",
  settlementAmount: "Settlement amount",
  sortCode: "Sort code",
  swiftBic: "Swift code (BIC)",
  testPayoutNotifications: "Test payout notifications",
  threshold: "Threshold",
  updateConfig: "Update config",
  virtualAccounts: "Virtual accounts",
  voltCashManagementBalance: "Volt Cash Management Balance",
  voltCashManagementBalanceCurrency:
    "Volt Cash Management Balance ({{currency}})",
  walletId: "Wallet ID",
  weHaveReceivedTestNotification:
    "We have received test notification request. Notifications will be disabled if webhook is incorrect",
  yourAccountNumberAndSortCodeToReceivePayments:
    "Your account number and sort code to receive payments from UK bank accounts",
  yourBSBAndAccountNumberToReceivePaymentsFromAU:
    "Your BSB and account number to receive payments from AU bank accounts",
};
